import { GroupItemBaseModel, GroupValueType } from '../group-item-base.model';
import { StepItemModel } from '../step';

export interface FormItemBaseModel extends GroupItemBaseModel {
  type: 'form';
}

export type SingleStepFormItemModel = StepItemModel;

export interface MultiStepFormItemModel extends FormItemBaseModel {
  isLinear?: boolean;
  items: StepItemModel[];
  buttonLabels?: {
    next: string;
    previous?: string;
    done?: string;
  };
}

export type FormItemModel = SingleStepFormItemModel | MultiStepFormItemModel;

export const isSingleStepForm = (form: FormItemModel): form is SingleStepFormItemModel => {
  return form.items[0]?.type !== 'step';
};

export interface FormStateModel {
  currentStep: number;
  value: GroupValueType;
}
